// Generated by purs version 0.15.15
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_CommutativeRing from "../Data.CommutativeRing/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Number_Format from "../Data.Number.Format/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var Pixel = function (x) {
    return x;
};
var showPixel = {
    show: function (v) {
        return "(Pixel " + (show(v) + ")");
    }
};
var semiringPixel = Data_Semiring.semiringNumber;
var ringPixel = Data_Ring.ringNumber;
var ordPixel = Data_Ord.ordNumber;
var euclideanRingPixel = Data_EuclideanRing.euclideanRingNumber;
var eqPixel = Data_Eq.eqNumber;
var encodeJsonPixel = Data_Argonaut_Encode_Class.encodeJsonJNumber;
var decodeJsonPixel = Data_Argonaut_Decode_Class.decodeJsonNumber;
var commutativeRingPixel = Data_CommutativeRing.commutativeRingNumber;
var toStringRounded = function (v) {
    return Data_Number_Format.toStringWith(Data_Number_Format.fixed(2))(v);
};
var toString = function (v) {
    return show(v);
};
var toNumber = function (v) {
    return v;
};
var scale = function (n) {
    return function (v) {
        return n * v;
    };
};
export {
    Pixel,
    scale,
    toNumber,
    toString,
    toStringRounded,
    eqPixel,
    ordPixel,
    semiringPixel,
    ringPixel,
    euclideanRingPixel,
    commutativeRingPixel,
    encodeJsonPixel,
    decodeJsonPixel,
    showPixel
};
